import React from "react";
import { Button } from "antd";
import { withRouter } from "react-router";
import PatentCenterLink from "../common/links/patent-center-link";

const styles = {
  fullWidthStyle: {
    width: "100%",
    padding: 64,
    textAlign: "center"
  },
  sideSpacing: {
    marginTop: 24,
    marginRight: 10,
    marginLeft: 10
  }
};

const NotFound = props => {
  return (
    <div style={styles.fullWidthStyle}>
      <h2>{`Ex-Parte Re-Exam Not Found`}</h2>
      <h3>{props.params.appnum} <PatentCenterLink value={props.params.appnum} /></h3>
      <Button type="primary" style={styles.sideSpacing} onClick={() => props.router.push("/exparte/search")}>
        {"New Search"}
      </Button>
    </div>
  );
};

export default withRouter(NotFound);
